import has from 'lodash/has';
import noop from 'lodash/noop';

class Meter {
  /**
   *
   * @param {'production'|'development'} environment
   * @param {boolean} hideSocialConnect
   * @param {boolean} hideProgressBar
   * @param {function} preExecuteCallback
   */
  constructor({
    environment,
    hideSocialConnect = false,
    hideProgressBar = false,
    preExecuteCallback = noop,
  }) {
    this.hideSocialConnect = hideSocialConnect;
    this.hideProgressBar = hideProgressBar;
    this.preExecuteCallback = preExecuteCallback;
    this.environment = environment;

    if (environment === 'development') {
      this.baseUrl = 'meter-qa.bostonglobe.com';
    } else {
      this.baseUrl = 'meter.bostonglobe.com';
    }
  }

  // eslint-disable-next-line class-methods-use-this
  loadBlueconic() {
    return new Promise((resolve) => {
      // Set a timeout to ensure the meter loads.
      const loadTimeout = setTimeout(
        () => {
          resolve();
        },
        500,
      );

      const blueconicScriptTag = document.createElement('script');
      blueconicScriptTag.src = '//cdn.blueconic.net/bostonglobemedia.js';
      blueconicScriptTag.onload = () => {
        resolve();
        clearTimeout(loadTimeout);
      };
      // Fail gracefully.
      blueconicScriptTag.onerror = () => {
        resolve();
        clearTimeout(loadTimeout);
      };
      document.body.appendChild(blueconicScriptTag);
    });
  }

  load() {
    return new Promise((resolve, reject) => {
      if (!document) {
        throw new Error('render() called outside of browser render');
      }
      if (this.environment === 'development') {
        // eslint-disable-next-line no-console
        console.log('Skipping meter for local development');
        resolve();
        return;
      }
      const styleTag = document.createElement('link');
      styleTag.href = `//${this.baseUrl}/css/style.css`;
      styleTag.rel = 'stylesheet';
      document.head.appendChild(styleTag);

      this.loadBlueconic().then(() => {
        const scriptTag = document.createElement('script');
        scriptTag.src = `//${this.baseUrl}/js/meter.js`;
        scriptTag.onload = () => {
          resolve();
        };
        scriptTag.onerror = () => {
          if (this.environment === 'development') {
            console.error('Unable to load meter');
          }
          reject();
        };
        document.body.appendChild(scriptTag);
      });
    });
  }

  initializeMeter() {
    window.meterObject = window.meterObject || {};

    window.meterObject.options = {
      hideSocialConnect: this.hideSocialConnect,
      hideProgressBar: this.hideProgressBar,
    };

    if (has(window.meterObject, 'updateBaseUrl')) {
      window.meterObject.updateBaseUrl('https://bostonglobe.com');
    }

    if (this.preExecuteCallback) {
      this.preExecuteCallback();
    }
  }
}

export default Meter;
